import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { trackMenuClickUserAction } from '../../../../../../common/analytics/menu/MenuUserAction';
import { NavigationRoutes } from '../../../../../../modules/Header/constants/navigationRoutes';
import { RouteImage } from '../shared/RouteImage/RouteImage';
import { LIMITED_NAV_IMG_PATH } from './constants';
import { Description, DescriptionWrapper, Panel, RouteImagesWrapper, Subtitle, Title, } from './LimitedEditionsPanel.styled';
export const LimitedEditionsPanel = () => {
    const limitedRouteTitle = 'Limited & Ultra Limited';
    const luminoRouteTitle = 'Lumino';
    return (_jsxs(Panel, { children: [_jsxs(DescriptionWrapper, { children: [_jsx(Title, { children: "Limited Displates" }, void 0), _jsx(Subtitle, { children: "Packed with extra flair" }, void 0), _jsxs(Description, { children: ["Printed in a limited number of copies or available only for a short time. Grab yours before it disappears forever!", _jsx("br", {}, void 0), _jsx("br", {}, void 0), "For the most demanding collectors looking for that extra kick!", _jsx("br", {}, void 0), "Featuring hand-picked designs, re-imagined with the help of unique print enhancements and innovative tech."] }, void 0)] }, void 0), _jsxs(RouteImagesWrapper, { children: [_jsx(RouteImage, { alt: limitedRouteTitle, buttonText: "Discover all", dataTestId: "limited-editions-panel-limited", description: limitedRouteTitle, images: {
                            jpg: {
                                x1: `${LIMITED_NAV_IMG_PATH}/limited_v2@1x.jpg`,
                                x2: `${LIMITED_NAV_IMG_PATH}/limited_v2@2x.jpg`,
                            },
                            avif: {
                                x1: `${LIMITED_NAV_IMG_PATH}/limited_v2@1x.avif`,
                                x2: `${LIMITED_NAV_IMG_PATH}/limited_v2@2x.avif`,
                            },
                            webp: {
                                x1: `${LIMITED_NAV_IMG_PATH}/limited_v2@1x.webp`,
                                x2: `${LIMITED_NAV_IMG_PATH}/limited_v2@2x.webp`,
                            },
                        }, onClick: (event) => {
                            trackMenuClickUserAction({
                                event,
                                panelTitle: 'Limited Editions',
                                linkName: '',
                                columnTitle: limitedRouteTitle,
                                elementType: 'Link',
                            });
                        }, url: NavigationRoutes.LIMITED_EDITION }, void 0), _jsx(RouteImage, { alt: luminoRouteTitle, buttonText: "Discover all", dataTestId: "limited-editions-panel-lumino", description: luminoRouteTitle, images: {
                            jpg: {
                                x1: `${LIMITED_NAV_IMG_PATH}/lumino_v2@1x.jpg`,
                                x2: `${LIMITED_NAV_IMG_PATH}/lumino_v2@2x.jpg`,
                            },
                            avif: {
                                x1: `${LIMITED_NAV_IMG_PATH}/lumino_v2@1x.avif`,
                                x2: `${LIMITED_NAV_IMG_PATH}/lumino_v2@2x.avif`,
                            },
                            webp: {
                                x1: `${LIMITED_NAV_IMG_PATH}/lumino_v2@1x.webp`,
                                x2: `${LIMITED_NAV_IMG_PATH}/lumino_v2@2x.webp`,
                            },
                        }, onClick: (event) => {
                            trackMenuClickUserAction({
                                event,
                                panelTitle: 'Limited Editions',
                                linkName: '',
                                columnTitle: luminoRouteTitle,
                                elementType: 'Link',
                            });
                        }, url: NavigationRoutes.LUMINO }, void 0)] }, void 0)] }, void 0));
};
//# sourceMappingURL=LimitedEditionsPanel.js.map